import { LifecycleModel } from "./lifecyclemodel";
import { ThirdPartyInformationModel } from "./thirdpartyinformationmodel";
import { OwnershipInformationModel } from "./ownershipinformationmodel";
import { ProcessInformationModel } from "./processinformationmodel";
import { AssetHyperlinkModel } from "./assethyperlinkmodel";

export class AssetManagementModel {
    guid: string;
    name: string = "";
    description: string = "";
    reference: string;
    lifecycle?: LifecycleModel;
    thirdPartyInformation?: ThirdPartyInformationModel;
    ownershipInformation?: OwnershipInformationModel;
    processInformation?: ProcessInformationModel;
    hyperlinks: AssetHyperlinkModel[] = [];
    version: number;
}
